

angular
.module('inkfinder')
.factory('AppointmentAddFactory', function AppointmentAddFactory() {
  // Public variables
  AppointmentAddFactory.data = {};
  return AppointmentAddFactory;
});



// WEBPACK FOOTER //
// ./components/appointments/add/appointment-add.factory.js